// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPurseAccessDto
 */
export interface IPurseAccessDto {
    /**
     * 
     * @type {number}
     * @memberof IPurseAccessDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IPurseAccessDto
     */
    status: IPurseAccessDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IPurseAccessDto
     */
    lock_reason?: IPurseAccessDtoLockReasonEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPurseAccessDto
     */
    employee_unlock_forbidden?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPurseAccessDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN'
}
/**
* @export
* @enum {string}
*/
export enum IPurseAccessDtoLockReasonEnum {
    REPAYMENT_REQUIRED = 'REPAYMENT_REQUIRED',
    DOCUMENTATION_REQUIRED = 'DOCUMENTATION_REQUIRED',
    FRAUD_DETECTED = 'FRAUD_DETECTED',
    CARDHOLDERS_REQUEST = 'CARDHOLDERS_REQUEST'
}


/**
 * Check if a given object implements the IPurseAccessDto interface.
 */
export function instanceOfIPurseAccessDto(value: object): value is IPurseAccessDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function IPurseAccessDtoFromJSON(json: any): IPurseAccessDto {
    return IPurseAccessDtoFromJSONTyped(json, false);
}

export function IPurseAccessDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPurseAccessDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'lock_reason': json['lock_reason'] == null ? undefined : json['lock_reason'],
        'employee_unlock_forbidden': json['employee_unlock_forbidden'] == null ? undefined : json['employee_unlock_forbidden'],
    };
}

export function IPurseAccessDtoToJSON(json: any): IPurseAccessDto {
    return IPurseAccessDtoToJSONTyped(json, false);
}

export function IPurseAccessDtoToJSONTyped(value?: IPurseAccessDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'lock_reason': value['lock_reason'],
        'employee_unlock_forbidden': value['employee_unlock_forbidden'],
    };
}

